import { render, staticRenderFns } from "./AcknowledgementLetter.vue?vue&type=template&id=0ea0bf1c&scoped=true&"
import script from "./AcknowledgementLetter.vue?vue&type=script&lang=js&"
export * from "./AcknowledgementLetter.vue?vue&type=script&lang=js&"
import style0 from "./AcknowledgementLetter.vue?vue&type=style&index=0&id=0ea0bf1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea0bf1c",
  null
  
)

export default component.exports